import React from "react";
import { TableRow } from "@mui/material";
import CustomTable from "../../../../shared/components/CustomTable";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import { formatInternationalNumber } from "../../../../utils/format";
import {
    CountBadge,
    EmptyState,
    LedgerSection,
    LedgerSectionHeader,
    LedgerSubtitle,
    LedgerTitle,
    LedgerTitleGroup,
} from "../../components";

const SourceColumns = [
    { text: "Vật tư nguồn", icon: <></> },
    { text: "Đã xuất", icon: <></> },
    { text: "Đã tiêu hao quy đổi", icon: <></> },
    { text: "Nhà gia công còn giữ", icon: <></> },
];

const OutputColumns = [
    { text: "Vật tư nhận về", icon: <></> },
    { text: "Đã đề nghị", icon: <></> },
    { text: "Đã nhập", icon: <></> },
    { text: "Còn lại", icon: <></> },
];

const SourceRow = ({ item }: any) => (
    <TableRow>
        <StyledTableCell align="left">{item.material?.name}</StyledTableCell>
        <StyledTableCell align="left">{formatInternationalNumber(item.exported_quantity || 0)}</StyledTableCell>
        <StyledTableCell align="left">{formatInternationalNumber(item.source_consumed_quantity || 0)}</StyledTableCell>
        <StyledTableCell align="left">{formatInternationalNumber(item.provider_holding_quantity || 0)}</StyledTableCell>
    </TableRow>
);

const OutputRow = ({ item }: any) => (
    <TableRow>
        <StyledTableCell align="left">{item.material?.name || item.output_material?.name}</StyledTableCell>
        <StyledTableCell align="left">{formatInternationalNumber(item.requested_quantity || item.expected_output_quantity || 0)}</StyledTableCell>
        <StyledTableCell align="left">{formatInternationalNumber(item.imported_quantity || item.received_quantity || 0)}</StyledTableCell>
        <StyledTableCell align="left">{formatInternationalNumber(item.remaining_quantity || item.remaining_output_quantity || 0)}</StyledTableCell>
    </TableRow>
);

export const BalanceSummary = ({ balanceSummary }: { balanceSummary?: any }) => {
    const sourceMaterials = balanceSummary?.source_materials || [];
    const legacyReturnPlans = balanceSummary?.return_plans || [];
    const outputMaterials = (balanceSummary?.output_materials || []).length
        ? balanceSummary?.output_materials
        : legacyReturnPlans.map((plan: any) => ({
              material: plan.output_material,
              requested_quantity: plan.expected_output_quantity,
              imported_quantity: plan.received_quantity,
              remaining_quantity: plan.remaining_output_quantity,
          }));

    return (
        <LedgerSection>
            <LedgerSectionHeader>
                <LedgerTitleGroup>
                    <LedgerTitle>Theo dõi gia công</LedgerTitle>
                    <LedgerSubtitle>Số lượng đã xuất, đã tiêu hao quy đổi, đã nhập và còn giữ.</LedgerSubtitle>
                </LedgerTitleGroup>
                <CountBadge>{outputMaterials.length}</CountBadge>
            </LedgerSectionHeader>
            <CustomTable
                itemList={sourceMaterials}
                RowElement={SourceRow}
                TableColumns={SourceColumns}
            />
            {sourceMaterials.length === 0 && (
                <EmptyState>
                    <div className="title">Chưa có vật tư nguồn để theo dõi</div>
                    <div className="body">Sau khi xuất kho, hệ thống sẽ hiển thị số lượng nhà gia công đang giữ.</div>
                </EmptyState>
            )}
            <CustomTable
                itemList={outputMaterials}
                RowElement={OutputRow}
                TableColumns={OutputColumns}
            />
            {outputMaterials.length === 0 && (
                <EmptyState>
                    <div className="title">Chưa có vật tư nhận về để theo dõi</div>
                    <div className="body">Tạo đề nghị nhập kho để xem số lượng đã đề nghị, đã nhập và còn lại.</div>
                </EmptyState>
            )}
        </LedgerSection>
    );
};
